module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// /Users/alextaxiera/source/farmhand-server/client/landing-page/~/core-js/library/modules/_add-to-unscopables.js
// module id = ../../node_modules/core-js/library/modules/_add-to-unscopables.js
// module chunks = 1